module.exports = __webpack_public_path__ + "static/img/modal_bgc.dd2048d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/courselist/modal_bgc.png
// module id = hrPy
// module chunks = 23